/** Returns `markedAt` unless it is in the future relative to `now`. */
export const clampMarkedAtToNow = (markedAt: Date, now: Date = new Date()): Date => {
  const markedMs = markedAt.getTime();
  const nowMs = now.getTime();
  if (!Number.isFinite(markedMs) || !Number.isFinite(nowMs)) {
    return now;
  }
  return markedMs > nowMs ? new Date(nowMs) : markedAt;
};

export const isMarkedAtInFuture = (markedAt: Date, now: Date = new Date()): boolean =>
  Number.isFinite(markedAt.getTime()) && markedAt.getTime() > now.getTime();
